import { ContentType, HttpClient, RequestParams } from './base/BaseHttpClient'
import { useHttpClient } from './base/HttpClient'
import { SubmitStripeConsentRequest, SubscriptionDto } from './contracts/models'

export class SubscriptionApi<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags Subscription
   * @name GetUserSubscription
   * @request GET:/api/subscription
   * @secure
   * @response `200` `SubscriptionDto` Success
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getUserSubscription = (params: RequestParams = {}) =>
    this.http
      .request<SubscriptionDto, void>({
        path: `/api/subscription`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      })
      .then((m) => m.data) /**
   * No description
   *
   * @tags Subscription
   * @name CreateCheckoutSession
   * @request POST:/api/subscription/create-checkout-session
   * @secure
   * @response `200` `string` Success
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  createCheckoutSession = (data: string, params: RequestParams = {}) =>
    this.http
      .request<string, void>({
        path: `/api/subscription/create-checkout-session`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      })
      .then((m) => m.data) /**
   * No description
   *
   * @tags Subscription
   * @name CreateCustomerSession
   * @request POST:/api/subscription/create-customer-session
   * @secure
   * @response `200` `string` Success
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  createCustomerSession = (params: RequestParams = {}) =>
    this.http
      .request<string, void>({
        path: `/api/subscription/create-customer-session`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      })
      .then((m) => m.data) /**
   * No description
   *
   * @tags Subscription
   * @name CustomerPortal
   * @request POST:/api/subscription/customer-portal
   * @secure
   * @response `200` `string` Success
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  customerPortal = (params: RequestParams = {}) =>
    this.http
      .request<string, void>({
        path: `/api/subscription/customer-portal`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      })
      .then((m) => m.data) /**
   * No description
   *
   * @tags Subscription
   * @name SubscriptionProviderWebhook
   * @request POST:/api/subscription/subscription-provider-webhook
   * @secure
   * @response `200` `void` Success
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  subscriptionProviderWebhook = (params: RequestParams = {}) =>
    this.http
      .request<void, void>({
        path: `/api/subscription/subscription-provider-webhook`,
        method: 'POST',
        secure: true,
        ...params,
      })
      .then((m) => m.data) /**
   * No description
   *
   * @tags Subscription
   * @name RevenueCatWebhook
   * @request POST:/api/subscription/revenuecat-webhook
   * @secure
   * @response `200` `void` Success
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  revenueCatWebhook = (params: RequestParams = {}) =>
    this.http
      .request<void, void>({
        path: `/api/subscription/revenuecat-webhook`,
        method: 'POST',
        secure: true,
        ...params,
      })
      .then((m) => m.data) /**
   * No description
   *
   * @tags Subscription
   * @name SubmitStripeMigrationConsent
   * @request POST:/api/subscription/stripe-migration-consent
   * @secure
   * @response `200` `void` Success
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  submitStripeMigrationConsent = (
    data: SubmitStripeConsentRequest,
    params: RequestParams = {},
  ) =>
    this.http
      .request<void, void>({
        path: `/api/subscription/stripe-migration-consent`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      })
      .then((m) => m.data)
}

const subscriptionApi = new SubscriptionApi(useHttpClient())
export function useSubscriptionApi(): SubscriptionApi {
  return subscriptionApi
}
